import { ChangeDetectionStrategy, Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

import { BaseCtrlValueAccessorFormArrayComponent, FormManagerService } from '@sim/form';
import { ClassName } from '@sim/role';

import { MTC, MTCMeta } from '@atmi/core/models/cards/card-f';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MtcExtendedFormComponent),
    },
    {
      multi: true,
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => MtcExtendedFormComponent),
    },
  ],
  selector: 'app-mtc-extended-form',
  styleUrls: ['./mtc-extended-form.component.scss'],
  templateUrl: './mtc-extended-form.component.html',
})
export class MtcExtendedFormComponent extends BaseCtrlValueAccessorFormArrayComponent<MTC> implements OnDestroy, OnInit {

  @Input() classNames: ClassName[] = [];

  constructor(
    private readonly formManager: FormManagerService,
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  addHandler() {
    if (!this.form || !this.form.controls) {
      throw new Error('Cannot manage MTC without a control');
    }

    const control = this.formManager.makeForm(MTCMeta, {} as MTC);
    this.form.push(control);
  }

  removeHandler(index: number) {
    if (!this.form || !this.form.controls) {
      throw new Error('Cannot manage MTC without a control');
    }

    this.form.removeAt(index);
  }
}
